/* eslint-disable react/require-default-props */
import React from 'react';
import { useSelector } from 'react-redux';
import PillButton from 'components/atoms/pill_button';
import { ambassadorFeedbackPath, findAmbassadorToolState } from 'services/ambassador';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';
import { Container, Spacer } from './styles';

interface AmbassadorFeedbackBarProps {
  toolSlug: string;
  /**
   * Em página que rola normalmente, reserva no fim do conteúdo a altura da
   * barra fixa, para ela não cobrir o final. Telas de altura fixa (chats)
   * descontam a altura no próprio layout.
   */
  reserveSpace?: boolean;
}

// O feedback aceita vários envios: depois do primeiro, a barra confirma o envio
// e continua aberta para um novo.
const AmbassadorFeedbackBar: React.FC<AmbassadorFeedbackBarProps> = ({
  toolSlug,
  reserveSpace = false,
}) => {
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);
  const { feedback_sent: feedbackSent } = findAmbassadorToolState(
    profile.ambassador?.tools,
    toolSlug,
  );

  return (
    <>
      {reserveSpace && <Spacer aria-hidden="true" />}
      <Container className="d-print-none">
        <div className="feedback-call">
          {feedbackSent ? (
            <>
              <span className="feedback-label">
                <i className="material-icons">check_circle</i>
                Feedback enviado
              </span>
              <strong className="feedback-title">Obrigado! Quer contar mais alguma coisa?</strong>
            </>
          ) : (
            <>
              <span className="feedback-label">Dê seu feedback</span>
              <strong className="feedback-title">Compartilhe conosco a sua experiência.</strong>
            </>
          )}
        </div>
        <PillButton to={ambassadorFeedbackPath(toolSlug)}>
          {feedbackSent ? 'Enviar outro feedback' : 'Compartilhar feedback'}
        </PillButton>
      </Container>
    </>
  );
};

export default AmbassadorFeedbackBar;
